import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';
import type { EnvironmentProviders } from '@angular/core';

export const provideTheme = (): EnvironmentProviders => providePrimeNG({
    theme: {
        preset: Lara,
        options: {
            prefix: '',
            // disable dark mode
            darkModeSelector: false,
            cssLayer: {
                name: 'primeng',
                order: 'reset, primeng, framework, base, layout, components, utilities',
            },
        },
    },
    translation: {
        aria: {
            maximizeLabel: 'Vollbild umschalten',
        },
    },
});
